import {
  Directive,
  ElementRef,
  HostBinding,
  Input,
} from '@angular/core';

@Directive({
  selector: '[jdDisabled]'
})
export class DisabledDirective {
  @HostBinding('class.ant-input-disabled') isDisabled = false;

  @Input('jdDisabled')
  set jdDisabled(value: boolean) {
    if (this.el && this.el.nativeElement) {
      this.el.nativeElement.disabled = value;
      this.isDisabled = value;
    }
  }

  constructor(private el: ElementRef) {}
}
